/**
 * Who sees "Shopify WA Inbox" (clensta.com website-order WhatsApp number
 * +91 84483 00516): admins (role 1) + this allowlist. Imported by the menu
 * (MainDashboard/index.js) and the page (ShopifyWaInbox.js). The backend
 * enforces the same list on /api/ai/shopify-wa/*: SHOPIFY_WA_INBOX_PHONES in
 * manijment-api services/ai-service/routes.js — keep the two in sync.
 */
import { getDecryptDataFromLocal } from "../../utils/encrypt";

export const SHOPIFY_WA_INBOX_PHONES = ["9354530453", "9999605299"];

export const canAccessShopifyWaInbox = () => {
  try {
    return getDecryptDataFromLocal("setRole") == 1
      || SHOPIFY_WA_INBOX_PHONES.includes(String(getDecryptDataFromLocal("phoneNumber")));
  } catch (e) {
    return false;
  }
};
